import React from "reactn";
// import { background1, background2 } from "../../assets";
import axios from "axios";
import "../../assets/css/componentSpecificCss/programManage.css";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/opacity.css";
import { InviteOverview } from "../../components/partner/InviteOverview";

class OnlineVirtualManage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      filter: "",
      detailsModalShown: false,
      modalData: [],
      original: {},
      role: [],
      totalInvites: 0,
      invitesAccepted: 0,
    };
    this.setGlobal({
      partnerPathway: [
        ...this.global.partnerPathway.slice(0, 1),
        { label: "Manage Online Virtual", to: "/online/manage" }
      ]
    });
  }

  async componentDidMount() {
    const startTime = new Date().getTime();
    this.setGlobal({ loading: true });
    const ep = `${process.env.REACT_APP_API}/partners/virtual/list_manage`;
    const results = await axios.get(ep);

    const role = await this.filterProgramsBasedUser();

    let data = results.data.data;

    if (results.data.success) {
      if (role?.onlinelist?.length > 0 && !role?.onlinelist?.includes(0)) {
        // [0] represents all listings access
        data = data.filter(
          e => role?.onlinelist?.filter(f => f === e.id).length > 0
        );
      } else if (role?.onlinelist === null || role?.onlinelist?.length === 0) {
        data = [];
      }

      const published = data
        .filter(item => item.published)
        .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
        .sort((a, b) => a.display_order - b.display_order);
      const unpublished = data
        .filter(item => !item.published)
        .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));

      const allPrograms = published.concat(unpublished);

      this.setState({
        data: allPrograms
      });
    }

    const ep2 = `${process.env.REACT_APP_API}/partners/invitations/overview/online`;
    const results2 = await axios.get(ep2);
    if (results2.data.success) {
      this.setState({
        totalInvites: results2.data.data.totalInvites,
        invitesAccepted: results2.data.data.invitesAccepted
      });
    }
    this.setGlobal({ loading: false });
    console.log("Time Taken", new Date().getTime() - startTime);
  }

  filterProgramsBasedUser = async () => {
    if (this.global?.dsUser?.sub_user && this.global?.dsUser?.role) {
      const ep = `${process.env.REACT_APP_API}/partners/users/all-details/${this.global?.dsUser?.user_id}`;

      const results = await axios.get(ep);
      console.log("results", results);
      if (results.data.success) {
        this.setState({
          role: results.data.data
        });
        return results.data.data;
      }
    }
    return {};
  };

  viewDetail = async row => {
    this.setState({ detailsModalShown: true, modalData: row });
  };
  viewComments = async row => {
    this.setState({ commentsModalShown: true, modalData: row });
  };
  daysInSystem = (r, i) => {
    return (
      <td key={i}>
        {parseInt((Date.now() - new Date(r.insys).getTime()) / (3600000 * 24))}
      </td>
    );
  };

  render() {
    return (
      <div className="admin">
        <div className="container-fluid adminprofiles">
          <div className="cont invites-title-wrapper">
            <div>
              <h1>Online Virtual</h1>
            </div>
            <InviteOverview
              totalInvites={this.state.totalInvites}
              invitesAccepted={this.state.invitesAccepted}
              listingType="Online Virtual"
            />
          </div>

          <div className="cont">
            {this.state.data.length > 0 ? (
              <div className="tablecont">
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {this.state.data.map((e, key) => (
                    <div
                      className="program-cards"
                      style={{
                        backgroundColor: "white",
                        width: "250px",
                        borderRadius: "10px",
                        marginRight: "20px",
                        marginBottom: "20px",
                        cursor: "pointer"
                      }}
                      key={key}
                      onClick={_ =>
                        this.props.history.push(
                          `/partners/virtual/manage/single/${e.id}`
                        )
                      }
                    >
                      <div
                        style={{
                          width: "100%",
                          height: "200px"
                        }}
                      >
                        <LazyLoadImage
                          src={`${process.env.REACT_APP_DS_FILES_S3}/${e.program_photo}`}
                          alt="Program"
                          style={{
                            width: "100%",
                            height: "100%",
                            borderTopLeftRadius: "10px",
                            borderTopRightRadius: "10px",
                            objectFit: "cover"
                          }}
                          wrapperProps={{
                            style: {
                              width: "100%",
                              height: "100%",
                              borderTopLeftRadius: "10px",
                              borderTopRightRadius: "10px",
                              objectFit: "cover"
                            }
                          }}
                          effect="opacity"
                        />
                      </div>
                      <p
                        style={{
                          textAlign: "center",
                          color: "black",
                          fontWeight: "bold",
                          fontSize: "12px",
                          marginTop: "5px",
                          marginBottom: "5px"
                        }}
                      >
                        {e.program_name}
                      </p>
                      <p
                        style={{
                          textAlign: "center",
                          color: "grey",
                          fontSize: "10px",
                          marginTop: "5px",
                          marginBottom: "5px"
                        }}
                      >
                        {e.program_category}
                      </p>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "5px"
                        }}
                      >
                        <span
                          style={{
                            flexGrow: 1,
                            color: "lightgrey",
                            fontSize: "12px",
                            marginLeft: "10px"
                          }}
                        >
                          {/* {key + 1} / {this.state.data.length} */}
                          {e.unlimited_spots ? (
                            <strong
                              style={{
                                flexGrow: 1,
                                color: "#1BC889",
                                fontSize: "12px",
                                marginLeft: "0px"
                              }}
                            >
                              Unlimited Spots
                            </strong>
                          ) : e.enrolledNum / e.total_spots >= 1 ? (
                            <strong
                              style={{
                                flexGrow: 1,
                                color: "#1BC889",
                                fontSize: "12px",
                                marginLeft: "0px"
                              }}
                            >
                              Full
                            </strong>
                          ) : (
                            `${e.enrolledNum} enrolled / ${
                              e.total_spots ? e.total_spots : "0"
                            } spots`
                          )}
                        </span>
                        <img
                          src="/static/media/monthlysurvey.122ae06e.svg"
                          alt=""
                          style={{ marginRight: "10px" }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  height: "60vh",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <p
                  style={{
                    fontStyle: "italic",
                    textAlign: "center",
                    fontSize: "18px"
                  }}
                >
                  Click{" "}
                  <b>
                    <Link to="/partners/online">here</Link>
                  </b>{" "}
                  to start creating your own Online Virtual programs!
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default OnlineVirtualManage;
